import { render, staticRenderFns } from "./BeltContainer.vue?vue&type=template&id=5c9e88f6&scoped=true"
import script from "./BeltContainer.vue?vue&type=script&lang=js"
export * from "./BeltContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9e88f6",
  null
  
)

export default component.exports